export const mainColName = 'ads'
export const UID = 'uid'


